import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpApi from 'i18next-http-backend'

// Function to escape apostrophes in translation strings
const escapeApostrophes = (text) => {
    if (!text || typeof text !== 'string') return text
    return text.replace(/'/g, '&#39;')
}

// Custom formatter to escape apostrophes in all translation values
const apostropheEscapeFormatter = {
    name: 'apostropheEscape',
    format: (value, lng, options) => {
        // Only process string values
        if (typeof value === 'string') {
            return escapeApostrophes(value)
        }
        return value
    }
}

i18n
    .use(HttpApi) // loads translations from your backend server
    .use(LanguageDetector) // detects user language
    .use(initReactI18next) // passes the i18n instance to react-i18next
    .init({
        fallbackLng: 'en', // default language
        supportedLngs: [
            "af",
            "am",
            "ar",
            "bg",
            "bn",
            "bs",
            "ca",
            "chr",
            "cr",
            "cs",
            "da",
            "de",
            "el",
            "en",
            "es-419",
            "es-ES",
            "esu",
            "et",
            "fi",
            "fr",
            "fr-CA",
            "gu",
            "ha",
            "he",
            "hi-IN",
            "hr",
            "hu",
            "hy",
            "id",
            "ig",
            "is",
            "it",
            "iu",
            "ja",
            "ka",
            "kk",
            "km",
            "kn",
            "ko",
            "lt",
            "lv",
            "mk",
            "ml",
            "mn",
            "mr",
            "ms",
            "my",
            "nb",
            "ne-IN",
            "nl",
            "nv",
            "ojb",
            "pa",
            "pcm",
            "pl",
            "pt-BR",
            "pt-PT",
            "ro",
            "ru",
            "sk",
            "sl",
            "so",
            "sq",
            "sr",
            "sv",
            "sw",
            "ta",
            "te",
            "th",
            "tl",
            "tr",
            "uk",
            "ur",
            "vi",
            "yo",
            "zh",
            "zh-CN",
            "zh-HK",
            "zh-TW",
            "zu"
        ], // supported languages
        backend: {
            loadPath: '/locales/{{lng}}/translation.json', // path to translation files
            crossDomain: true,
            withCredentials: false,
            requestOptions: {
                mode: 'cors',
                credentials: 'same-origin',
                cache: 'default'
            }
        },
        detection: {
            order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
            caches: ['cookie'],
        },
        interpolation: {
            escapeValue: false, // React already does escaping
            format: function(value, format, lng, options) {
                // Always apply apostrophe escaping to string values
                if (typeof value === 'string') {
                    return escapeApostrophes(value)
                }
                return value
            }
        },
    })

export default i18n